import React, { useEffect, useState } from "react";
import TextTransition, { presets } from "react-text-transition";
import WaterWaveWrapper from "../WaterWaveWrapper";

export default function Hero({ title, subtitle, bgUrl, imgStyle }) {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((prevIndex) => prevIndex + 1),
      3000 // every 3 seconds
    );

    return () => clearInterval(intervalId); // Use clearInterval here
  }, []);
  return (
    <section
      className="cs_hero cs_style_1 cs_primary_bg position-relative"
      style={{ paddingTop: "120px" }}
    >
      <div className="container">
        <div className="cs_hero_text text-center position-relative">
          <p className="cs_hero_subtitle cs_accent_color cs_medium cs_fs_18 cs_dancing_animation">
            <TextTransition springConfig={presets.wobbly}>
              {title[index % title.length]}
            </TextTransition>
          </p>
          <h1 className="cs_hero_title cs_white_color cs_fs_68 cs_dancing_animation">
            {subtitle}
          </h1>
          <p></p>
        </div>
        <div className="cs_hero_shape position-absolute">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={220}
            height={220}
            viewBox="0 0 24 24"
          >
            <path
              opacity="0.15"
              fill="#fff"
              d="M3.81 6.28C2.67 7.9 2 9.87 2 12s.67 4.1 1.81 5.72C6.23 16.95 8 14.68 8 12S6.23 7.05 3.81 6.28m16.38 0C17.77 7.05 16 9.32 16 12s1.77 4.95 4.19 5.72C21.33 16.1 22 14.13 22 12s-.67-4.1-1.81-5.72"
            />
            <path
              opacity="0.15"
              fill="#fff"
              d="M14 12c0-3.28 1.97-6.09 4.79-7.33C17.01 3.02 14.63 2 12 2S6.99 3.02 5.21 4.67C8.03 5.91 10 8.72 10 12s-1.97 6.09-4.79 7.33C6.99 20.98 9.37 22 12 22s5.01-1.02 6.79-2.67A8 8 0 0 1 14 12"
            />
          </svg>
        </div>
      </div>
      <div className="cs_video_block_wrap position-relative">
        <div className="container">
          <WaterWaveWrapper
            className="cs_video_block cs_style_1 cs_bg_filed cs_radius_15 position-relative d-flex justify-content-center align-items-center cs_ripple_activate overflow-hidden"
            imageUrl={bgUrl}
            style={imgStyle}
            fallbackClassName="cs_static_banner"
          >
            {() => <div></div>}
          </WaterWaveWrapper>
        </div>
      </div>
    </section>
  );
}
